module.exports = __webpack_public_path__ + "media/failure_short.afbd7e6a.flac";